//! ***** Wishlist functionality
document.addEventListener("DOMContentLoaded", () => {
  const wishlistBtns = document.querySelectorAll(".wishlist-btn");

  wishlistBtns.forEach((btn) => {
    const productId = btn.getAttribute("data-product-id");
    if (isProductInWishlist(productId)) {
      btn.classList.add("active");
    }

    btn.addEventListener("click", () => {
      const product = {
        id: productId,
        title: btn.getAttribute("data-product-title"),
        price: parseFloat(btn.getAttribute("data-product-price")),
        comparePrice:
          parseFloat(btn.getAttribute("data-product-compare-price")) || null, // Handle case where compare price might be null
        imageUrl: btn.getAttribute("data-product-image"),
        url: btn.getAttribute("data-product-url"),
        rating: btn.getAttribute("data-product-rating"),
        button: btn.getAttribute("data-product-button"),
      };
      toggleWishlistProduct(product, btn);
    });
  });

  function isProductInWishlist(productId) {
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    return wishlist.some((product) => product.id === productId);
  }

  function toggleWishlistProduct(product, btn) {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    if (isProductInWishlist(product.id)) {
      wishlist = wishlist.filter((p) => p.id !== product.id);
      btn.classList.remove("active");
    } else {
      wishlist.push(product);
      btn.classList.add("active");
    }

    localStorage.setItem("wishlist", JSON.stringify(wishlist));
    renderWishlist();
  }

  function renderWishlist() {
    const wishlistContainer = document.querySelector(".wishlist-container");

    if (!wishlistContainer) return;

    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    wishlistContainer.innerHTML = "";

    if (wishlist.length === 0) {
      wishlistContainer.innerHTML = "<p>Your wishlist is empty.</p>";
      return;
    }

    wishlist.forEach((product) => {
      const discountPercentage =
        product.comparePrice &&
        parseFloat(product.comparePrice) > parseFloat(product.price)
          ? Math.round(
              ((parseFloat(product.comparePrice) - parseFloat(product.price)) *
                100) /
                parseFloat(product.comparePrice)
            )
          : null;

      const productCard = `
        <div class="product-card relative h-[454px] w-[316px] max-w-full flex justify-center" data-product-id="${
          product.id
        }">
          ${
            product.comparePrice
              ? `
              <svg width="316" height="454" fill="none" xmlns="http://www.w3.org/2000/svg" class="product-background"><path d="m20.743 108.494-.062-.068-.015-.016-.042-.045-.077-.084-.16-.174-.32-.348-.321-.348-.191-.208c-.687-.767-1.362-1.546-2.076-2.298a27.311 27.311 0 0 0-2.14-2.073l-.022-.001c-.015-.017-.03-.034-.058-.04-.005-.006-.015-.017-.026-.017l-.005-.006-.005-.006a1.126 1.126 0 0 1-.026-.028l-10.091 10.52c-.029.026-.019.048.013.06l13.526 4.652a.108.108 0 0 1 .046.051l5.56 15.485c.019.055.046.062.08.009l18.76-26.707-22.33 1.766c-.008-.054.012-.021-.018-.065" fill="#E95100"/><path d="m36.179 100.263 6.884 7.474-22.392 1.577c-.077.008-.082-.009-.015-.05a269.084 269.084 0 0 0 15.517-9.006l.006.005zM112.848 44.409l-7.311-7.937-.011-.012a267.038 267.038 0 0 0 10.207-14.778c.035-.053.051-.047.038.02-.947 7.453-1.889 14.913-2.836 22.379-.021.16-.052.274-.093.333l.006-.005z" fill="#A00"/><path d="M108.629 14.905s.016.017.033.001l12.3-9.278c.029-.027.05-.015.059.018l3.38 15.197.036.04 15.827 5.939c.027.006.026.028.009.044-.029.026-.069.063-.119.088l-28.487 17.26c-.023.02-.05.003-.059-.03.047-.064.073-.172.097-.33 1.05-7.374 2.094-14.743 3.144-22.106.008-.06-.008-.066-.038-.018" fill="#E95100"/><g filter="url(#a)"><path d="M293.194 31.084h-253c-6.627 0-12 5.373-12 12v384c0 6.627 5.373 12 12 12h253c6.628 0 12-5.373 12-12v-384c0-6.627-5.372-12-12-12z" fill="#fff"/></g><g filter="url(#b)"><path d="M97.63 2.02c-6.03 8.353-12.271 16.543-18.852 24.547-6.794 8.265-13.886 16.17-21.468 23.704a237.558 237.558 0 0 1-15.58 14.194 201.138 201.138 0 0 1-19.479 14.352A179.343 179.343 0 0 1 2.007 90.115c-.011.01-.007.027-.001.033l12.62 13.7.01.011c.006-.005.023-.01.028-.004.032.013.06.03.086.048.005-.005.022.001.032.012.436.37.854.767 1.266 1.169.744.739 1.45 1.505 2.149 2.287.699.781 1.381 1.568 2.092 2.339.01.012.015.017.01.034l.005.005.005.006a267.74 267.74 0 0 0 15.563-9.045c1.438-.902 2.68-1.698 3.726-2.377 25.655-16.682 47.618-37.294 65.909-61.821.017-.016.028-.026.05-.026-.011-.01-.011-.01-.005-.016a273.846 273.846 0 0 0 10.232-14.695l-6.243-6.891L97.689 2.017c-.025-.028-.036-.018-.06.003z" fill="#E95100"/></g><defs><filter id="a" x="18.194" y="25.084" width="297" height="428" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_583_2074"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_583_2074" result="shape"/></filter><filter id="b" x="0" y="0" width="121.784" height="115.756" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dx="2" dy="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_583_2074"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_583_2074" result="shape"/></filter></defs></svg>
          `
              : `
            <svg width="314" height="452" fill="none" xmlns="http://www.w3.org/2000/svg" class="product-background"><g filter="url(#a)"><path d="M291.194 29.084h-253c-6.627 0-12 5.373-12 12v384c0 6.627 5.373 12 12 12h253c6.628 0 12-5.373 12-12v-384c0-6.627-5.372-12-12-12z" fill="#fff"/></g><defs><filter id="a" x="16.194" y="23.084" width="297" height="428" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_605_1949"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_605_1949" result="shape"/></filter></defs></svg>
          `
          }
          ${
            discountPercentage
              ? `<div class="discount-percentage text-red-500 font-bebas text-[18px]">${discountPercentage}% OFF</div>`
              : ""
          }
          <button name="Wishlist button" class="wishlist-btn active" data-product-id="${
            product.id
          }" data-product-title="${product.title}" data-product-price="${
        product.price
      }" data-product-compare-price="${
        product.comparePrice
      }" data-product-image="${product.imageUrl}" data-product-url="${
        product.url
      }" data-product-button="${product.button}">
            <svg width="22" height="20" viewBox="0 0 22 20" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.73989 18.19L9.73917 18.1894C6.89654 15.6353 4.57781 13.5512 2.96372 11.5959C1.35522 9.64735 0.5 7.88874 0.5 5.99455C0.5 2.91808 2.93379 0.5 6.05 0.5C7.81432 0.5 9.51418 1.31622 10.6208 2.60383L11 3.04504L11.3792 2.60383C12.4858 1.31622 14.1857 0.5 15.95 0.5C19.0662 0.5 21.5 2.91808 21.5 5.99455C21.5 7.88875 20.6448 9.64738 19.0362 11.5974C17.4251 13.5503 15.1122 15.6329 12.277 18.1857L12.2615 18.1997L12.2604 18.2006L11.0013 19.3278L9.73989 18.19Z" stroke="#E95100"/>
            </svg>
          </button>
          <div class="content w-full flex flex-col justify-center items-center p-7 pt-10 ml-[13px]">
            <a href="${product.url}" class="block h-fit w-fit">
              <div>
                <img width="88" height="150" class="object-contain h-[150px] w-[88px]" src="${
                  product.imageUrl
                }" alt="${product.title}" loading="lazy">
              </div>
            </a>
            <a href="${
              product.url
            }" class="text-[var(--black)] text-center capitalize font-bold mt-[10px]">${
        product.title
      }</a>
            <div class="jdgm-widget jdgm-preview-badge cursor-default mt-[10px]" data-id="${
              product.id
            }">${product.rating}</div>
            <div class="flex gap-[5px] text-center mt-[10px]">
              <span class="text-[var(--main-color)] font-medium text-[16px] underline">${formatMoney(
                product.price
              )}</span>
              ${
                product.comparePrice
                  ? '<span class="text-black text-[14px] opacity-50 line-through self-end">' +
                    formatMoney(product.comparePrice) +
                    "</span>"
                  : ""
              }
            </div>
            <div class="buttons mt-5 flex flex-wrap justify-center gap-[15px]">
              <button class="add-to-cart-btn border border-[var(--vibrant-orange)] rounded-[14px] w-[100px] px-2 py-[2px] text-[var(--vibrant-orange)] font-bold transition duration-300 ease-in-out hover:bg-[var(--vibrant-orange)] hover:text-white" data-product-id="${
                product.button
              }">Add to Cart</button>
              <button class="buy-now-btn border border-[transparent] bg-[var(--vibrant-orange)] text-white font-bold rounded-[14px] w-[100px] px-2 py-[2px] transition duration-300 ease-in-out hover:bg-[var(--main-color)] hover:text-white" data-product-id="${
                product.button
              }">Buy Now</button>
            </div>
          </div>
        </div>
      `;

      wishlistContainer.innerHTML += productCard;
    });

    // Attach event listeners for Add to Cart and Buy Now buttons after rendering
    document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
      button.addEventListener("click", function () {
        const productId = this.dataset.productId;
        addToCart(productId);
      });
    });

    document.querySelectorAll(".buy-now-btn").forEach((button) => {
      button.addEventListener("click", function () {
        const productId = this.dataset.productId;
        buyNow(productId);
      });
    });

    // Attach event listeners for wishlist buttons in the rendered wishlist
    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const productId = btn.getAttribute("data-product-id");

      btn.addEventListener("click", () => {
        const product = {
          id: productId,
          title: btn.getAttribute("data-product-title"),
          price: parseFloat(btn.getAttribute("data-product-price")),
          comparePrice:
            parseFloat(btn.getAttribute("data-product-compare-price")) || null, // Handle case where compare price might be null
          imageUrl: btn.getAttribute("data-product-image"),
          url: btn.getAttribute("data-product-url"),
          rating: btn.getAttribute("data-product-rating"),
          button: btn.getAttribute("data-product-button"),
        };
        toggleWishlistProduct(product, btn);
      });
    });
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2); // Adjust this according to your currency format
  }

  renderWishlist(); // Initial render of the wishlist
});

//! Add to cart and buy now buttons

const cartCountElement = document.querySelector(".cart-btn .cart-count");

document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
  button.addEventListener("click", function () {
    const productId = this.dataset.productId;
    addToCart(productId);
  });
});

document.querySelectorAll(".buy-now-btn").forEach((button) => {
  button.addEventListener("click", function () {
    const productId = this.dataset.productId;
    buyNow(productId);
  });
});

function addToCart(productId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: productId,
          quantity: 1,
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Product added to cart:", data);
      updateCartCount();
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
}

function buyNow(productId) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      items: [
        {
          id: productId,
          quantity: 1,
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Product added to cart for checkout:", data);
      window.location.href = "/checkout";
    })
    .catch((error) => {
      console.error("Error adding product to cart for checkout:", error);
    });
}

function updateCartCount() {
  fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (cartCountElement) {
        cartCountElement.textContent =
          data.item_count > 0 ? data.item_count : "";
        cartCountElement.style.display = data.item_count > 0 ? "flex" : "none";
      }
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}

// Initial cart count update
updateCartCount();
//! ***** End Wishlist functionality
